


  
  

  var faAt = {
    prefix: 'fal',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 24c0 48.6-39.4 88-88 88c-33.4 0-62.5-18.7-77.4-46.1c-20.4 28-53.4 46.1-90.6 46.1c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6l0-1.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 0 24c0 30.9 25.1 56 56 56s56-25.1 56-56l0-24C480 132.3 379.7 32 256 32zm80 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faBath = {
    prefix: 'fal',
    iconName: 'bath',
    icon: [
      512,
      512,
      [128705,"bathtub"],
      'f2cd',
      
      'M93.3 32C77.1 32 64 45.1 64 61.3L64 256l384 0 32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-32 0L64 288l-32 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0L32 61.3C32 27.4 59.4 0 93.3 0c16.2 0 31.8 6.5 43.3 17.9L161.7 43c11.1-7 24.2-11 38.3-11c20.2 0 38.5 8.3 51.6 21.8l1.1-1.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-104 104c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3L113.9 40.6C108.5 35.1 101 32 93.3 32zM32 320l32 0 0 48c0 26.2 12.6 49.4 32 64c0 0 0 0 0 0s0 0 0 0c13.4 10 30 16 48 16l224 0c18 0 34.6-6 48-16c0 0 0 0 0 0s0 0 0 0c19.4-14.6 32-37.8 32-64l0-48 32 0 0 48c0 30.5-12.2 58.2-32 78.4l0 49.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-26.8c-14.5 6.9-30.8 10.8-48 10.8l-224 0c-17.2 0-33.5-3.9-48-10.8L96 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-49.6C44.2 426.2 32 398.5 32 368l0-48zM200 64c-22.1 0-40 17.9-40 40c0 11.4 4.8 21.7 12.4 29L229 76.4C221.7 68.8 211.4 64 200 64z'
      
    ]
  };

  
    var faBathtub = faBath;
  

  
  

  var faBedFront = {
    prefix: 'fal',
    iconName: 'bed-front',
    icon: [
      512,
      512,
      ["bed-alt"],
      'f8f7',
      
      'M64 96l0 40.6c9.4-5.4 20.3-8.6 32-8.6l112 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l112 0c11.7 0 22.6 3.1 32 8.6L448 96c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zm416 96l0 48c19.4 14.6 32 37.8 32 64l0 96 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 416l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-96c0-26.2 12.6-49.4 32-64l0-48 0-96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 96zm-32 33.6l0-33.6c0-17.7-14.3-32-32-32l-112 0c-17.7 0-32 14.3-32 32l0 32 160 0c5.5 0 10.8 .6 16 1.6zM240 224l0-32c0-17.7-14.3-32-32-32L96 160c-17.7 0-32 14.3-32 32l0 33.6c5.2-1 10.5-1.6 16-1.6l160 0zm240 80c0-26.5-21.5-48-48-48L80 256c-26.5 0-48 21.5-48 48l0 80 448 0 0-80z'
      
    ]
  };

  
    var faBedAlt = faBedFront;
  

  
  

  var faCaretDown = {
    prefix: 'fal',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M165.6 349.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 236.3c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1l241.7 0c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 349.8zm22 23.3L307.7 259.6c7.8-7.4 12.3-17.7 12.3-28.4c0-21.6-17.5-39.1-39.1-39.1L39.1 192C17.5 192 0 209.5 0 231.1c0 10.8 4.4 21.1 12.3 28.5L132.4 373.1c7.4 7 17.3 10.9 27.6 10.9s20.1-3.9 27.6-10.9z'
      
    ]
  };

  

  
  

  var faCircleNotch = {
    prefix: 'fal',
    iconName: 'circle-notch',
    icon: [
      512,
      512,
      [],
      'f1ce',
      
      'M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9c-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z'
      
    ]
  };

  

  
  

  var faEnvelope = {
    prefix: 'fal',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9l0-39.9c0-17.7-14.3-32-32-32L64 96zM32 207.6L32 384c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-176.4L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z'
      
    ]
  };

  

  
  

  var faMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faPhone = {
    prefix: 'fal',
    iconName: 'phone',
    icon: [
      512,
      512,
      [128222,128379],
      'f095',
      
      'M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z'
      
    ]
  };

  

  
  

  var faRulerCombined = {
    prefix: 'fal',
    iconName: 'ruler-combined',
    icon: [
      512,
      512,
      [],
      'f546',
      
      'M192 192l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 288 0 96c0 1.1 .1 2.2 .2 3.3C33.8 467.4 47.5 480 64 480l96 0 288 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zm64 96l192 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-288 0-96 0C30.9 512 3.6 486.8 .3 454.5c-.2-2.2-.3-4.3-.3-6.5l0-96L0 64C0 28.7 28.7 0 64 0l96 0c35.3 0 64 28.7 64 64l0 192 0 32 32 0z'
      
    ]
  };

  



export {

  faAt,
  

  faBath,
  
  faBathtub,
  

  faBedFront,
  
  faBedAlt,
  

  faCaretDown,
  

  faCircleNotch,
  

  faEnvelope,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faPhone,
  

  faRulerCombined,
  

};
